<template>
  <div id="report-archive">
    <div class="row mt-md-5 article">
      <div class="col-md-12">
        <img src="/static/images/report/make_title.png" class="img-fluid">
      </div>
      <div class="col-md-12 report-title">
        <p>おひさまキッチンえほんのレシピをつくってくれた</p>
        <p>
          おともだちの報告です！
          <a href="javascript:void(0);" @click="scrollTo"><span>ほうこくの方法はこちら</span></a>
        </p>
      </div>
      <div class="col-md-12">
        <img src="/static/images/report/make_1.jpg" class="img-fluid">
      </div>
      <div class="col-md-12 report-body">
        <p>
          「パンダくんいそいで！」のおひさまアップルパイをつくってくれました！
          とっても美味しそうにレシピを再現してくれたよ！
        </p>
      </div>
      <div class="col-md-12 report-body-read">
        <p>
          おひさまアップルパイのレシピがのっている本は、
        </p>
      </div>
      <div class="col-md-12 col-lg-6">
        <img src="/static/images/book/isoide.png" class="img-fluid" alt="おひさまキッチン パンタくん いそいで！ 表紙画像">
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/isoide-title.png" class="preview img-fluid" alt="おひさまキッチン パンタくん いそいで！">
          </div>
          <div class="col-12">
            <p class="book-description">
              あさ、まだくらいうちから、パンダくんたちがおきて、
              なにかをしようとしています。とってもいそいでいるけど、
              さて、なんのじゅんびをしているのでしょう？
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2017/8/22 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-4929-6 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-6">
            <a href="https://pie.co.jp/book/i/4929/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid no-radius" alt="PIE通販購入する">
            </a>
          </div>
          <div class="col-6">
            <a href="https://www.amazon.co.jp/dp/4756249299" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid no-radius" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid line" alt="黄色の破線">
      </div>
      <div class="col-md-12">
        <img src="/static/images/report/make_2.jpg" class="img-fluid">
      </div>
      <div class="col-md-12 report-body">
        <p>
          「パンダくんプレゼントのもりへ」のうたうジンジャークッキーを
          クリスマスにつくってくれたよ！
        </p>
      </div>
      <div class="col-md-12 report-body-read">
        <p>
          うたうジンジャークッキーのレシピがのっている本は、
        </p>
      </div>
      <div class="col-md-12 col-lg-6">
        <img src="/static/images/book/mori.png" class="img-fluid" alt="おひさまキッチン パンタくんプレゼントのもりへ 表紙画像">
      </div>
      <div class="col-md-12 col-lg-6">
        <div class="row book-body">
          <div class="col-12">
            <img src="/static/images/book/mori-title.png" class="preview img-fluid" alt="おひさまキッチン パンタくんプレゼントのもりへ">
          </div>
          <div class="col-12">
            <p class="book-description">
              おひさまキッチンに、おさとうのゆきがふりはじめました。
              それはもうすぐ、クリスマスがやってくるあいずです。
              どうぶつさんたちは、どんなプレゼントを
              もらえるのでしょう？
            </p>
          </div>
          <div class="col-12">
            <p class="book-price">
              定価 本体 1,300 円 + 税
            </p>
          </div>
          <div class="col-12">
            <p class="book-spec">
              発売日: 2017/11/10 Format: A4 判変型 Size: 210x210mm<br>
              Pages: 32 ページ (全ページフルカラー) Binding: ハードカバー<br>
              ISBN: 978-4-7562-4967-8 発売元: パイ インターナショナル
            </p>
          </div>
          <div class="col-6">
            <a href="https://pie.co.jp/book/i/4967/" target="_blank">
              <img src="/static/images/book/buy-pie.png" class="img-fluid  no-radius" alt="PIE通販購入する">
            </a>
          </div>
          <div class="col-6">
            <a href="https://www.amazon.co.jp/dp/4756249671" target="_blank">
              <img src="/static/images/book/buy-amazon.png" class="img-fluid  no-radius" alt="Amazonで買う">
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-12 line">
        <img src="/static/images/common/line.png" class="img-fluid line" alt="黄色の破線">
      </div>
      <div class="col-md-12 report-bottom">
        <img src="/static/images/report/make_panda.png" class="img-fluid">
      </div>
      <div class="col-md-12 report-bottom" id="howto">
        <p>えほんのレシピを</p>
        <p class="hashtag">#つくったよ報告隊</p>
        <p class="hashtag">#おひさまキッチンえほん</p>
        <p>
        のハッシュタグをつけてSNSに投稿してね。<br>
        HPに掲載させていただいた方には、<br>
        おひさまキッチンオリジナルの<br>
        「クリアファイル4種 & 絵ハガキ5枚セット」<br>
        をお贈りさせていただきます。<br>
        ハガキの絵柄はパンダくんが心をこめて選ぶので、楽しみにしていてください！
        </p>
      </div>
      <div class="col-md-12 report-caution">
        <p>※掲載のご連絡はDMにてさせていただきます。ご連絡が取れない場合はプレゼントをお送りする事ができませんのでご了承ください。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: 'つくったよ報告隊!',
  name: 'report',
  components: {},
  mounted: function() {
    this.$nextTick(function () {
      try {
        FONTPLUS.reload();
      } catch (error) {
        console.log(error.message);
      }
    })
  },
  methods: {
    scrollTo: function(){
      var element = document.getElementById("howto").getBoundingClientRect();
      var top = element.top + window.pageYOffset;
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Report.vue